<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm cơ quan</div>
      <div v-else>Chỉnh sửa cơ quan</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm cơ quan'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã cơ quan*</label>
            <div class="p-col-8">
              <InputText v-model="code"  id="code" type="text" class="p-col-width" placeholder="Nhập mã cơ quan" />
              <small
                v-if="validationErrors && validationErrors['code']"
                class="p-invalid"
              >{{validationErrors['code']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã số thuế</label>
            <div class="p-col-8">
              <InputText v-model="tax_code"  id="tax_code" type="text" class="p-col-width" placeholder="Nhập mã số thuế" />
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Tên cơ quan*</label>
            <div class="p-col-8">
              <InputText v-model="name"  id="name" type="text" class="p-col-width" placeholder="Nhập tên cơ quan" />
              <small
                v-if="validationErrors && validationErrors['name']"
                class="p-invalid"
              >{{validationErrors['name']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Số điện thoại</label>
            <div class="p-col-8">
              <InputText v-model="phone"  id="phone" type="number" class="p-col-width" placeholder="Nhập số điện thoại" />
              <!--<InputMask  v-model="phone"  mask="9999999999" id="phone" type="number" class="p-col-width" placeholder="Nhập số điện thoại" />-->
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 10px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Địa chỉ</label>
            <div class="p-col-8">
              <InputText v-model="address"  id="address" type="text" class="p-col-width" placeholder="Nhập địa chỉ" />
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Văn phòng quản lý*</label>
            <div class="p-col-8">
              <MultiSelect v-model="selectedOfficeTpl" :options="this.listOfficeTpl" 
              optionLabel="name" placeholder="Chọn văn phòng quản lý" :filter="true">
              </MultiSelect>
              <small
                v-if="validationErrors && validationErrors['office_tpl']"
                class="p-invalid"
              >{{validationErrors['office_tpl']}}</small>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      address: '',
      name: '',
      tax_code: '',
      code: '',
      phone: '',
      listOfficeTpl: [],
      selectedOfficeTpl: [],
      listOfficeAgency: []
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.office_agency_id = this.$route.params.id
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      console.log('-------------------------------', this.selectedOfficeTpl)
      this.validationErrors = {};
      var has_error = false
      if (this.name === '') {
        this.validationErrors['name'] = 'Vui lòng nhập tên cơ quan';
        has_error = true
      }
      if (this.selectedOfficeTpl.length == 0) {
        this.validationErrors['office_tpl'] = 'Vui lòng chọn văn phòng quản lý';
        has_error = true
      }
      if (this.code === '') {
        this.validationErrors['code'] = 'Vui lòng nhập mã cơ quan';
        has_error = true
      } else {
        if (this.mode == 'add') {
          let query = `query MyQuery($code: String) {
            office_agency(where: {code: {_like: $code}, deleted: {_eq: false}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.office_agency[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã cơ quan bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            })
        } else {
          let query = `query MyQuery($code: String, $id: Int) {
            office_agency(where: {code: {_like: $code}, deleted: {_eq: false}, id: {_neq: $id}}) {
              id
            }
          }`
          await this.$apollo
            .query({
              query: gql(query),
              variables: {
                code: this.code,
                id: this.$route.params.id
              }
            })
            .then(async (res) => {
              console.log('res', res)
              if (res.data.office_agency[0]) {
                console.log('0000000000000000000000')
                this.validationErrors['code'] = 'Mã cơ quan bị trùng';
                has_error = true
                this.$forceUpdate() 
              }
            }) 
        }
      }
      return has_error
    },
    async analyzeData() {
      console.log('dâdadadadadadad')
      var data_office_agency = {}
        data_office_agency['tax_code'] = this.tax_code
        data_office_agency['name'] = this.name
        data_office_agency['code'] = this.code
        data_office_agency['phone'] = this.phone
        data_office_agency['address'] = this.address

        var data_item= []

        for (let i = 0; i < this.selectedOfficeTpl.length; i++) {
          const item = this.selectedOfficeTpl[i]
          var data_item_item= {}
          data_item_item['tpl_id'] = item.id
          data_item.push(data_item_item)
        }
        var data_office_agency_item = {}
        data_office_agency_item['data'] = data_item
        data_office_agency['office_agency_tpls'] = data_office_agency_item

      return data_office_agency
    },
    async analyzeDataEdit() {
      var data_office_agency = {}
        data_office_agency['tax_code'] = this.tax_code
        data_office_agency['name'] = this.name
        data_office_agency['code'] = this.code
        data_office_agency['phone'] = this.phone
        data_office_agency['address'] = this.address
      return data_office_agency
    },
    async analyzeDataEditItem() {
      var data_item= []
      for (let i = 0; i < this.selectedOfficeTpl.length; i++) {
          const item = this.selectedOfficeTpl[i]
          var data_item_item= {}
          data_item_item['agency_id'] = this.office_agency_id
          data_item_item['tpl_id'] = item.id
          data_item.push(data_item_item)
        }
      return data_item
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_office_agency = await this.analyzeData()

        var query = `mutation MyMutation($objects: [office_agency_insert_input!]!) {
            insert_office_agency(objects: $objects) {
              affected_rows
              returning {
                id
                name
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: [data_office_agency]
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-office_agency'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_office_agency_update = await this.analyzeDataEdit()
        let data_office_agency_item = await this.analyzeDataEditItem()
        let query = `mutation MyMutation($office_agency_id: Int!, $office_agency_update: office_agency_set_input, $objects: [office_agency_tpl_insert_input!]!) {
          update_office_agency(where: {id: {_eq: $office_agency_id}}, _set: $office_agency_update) {
            affected_rows
            returning {
              id
              name
            }
          }
          delete_office_agency_tpl(where: {agency_id: {_eq: $office_agency_id}}) {
            affected_rows
          }
          insert_office_agency_tpl(objects: $objects) {
            affected_rows
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              office_agency_id: this.office_agency_id,
              office_agency_update: data_office_agency_update,
              objects: data_office_agency_item
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-office_agency'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    office_tpl: {
      query() {
        let query = `
          query MyQuery {
            office_tpl(where: {deleted: {_eq: false}}) {
              id
              name
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.office_tpl){
          this.listOfficeTpl = data.office_tpl
        }
      },
      fetchPolicy: "network-only",
    },
    office_agency: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            office_agency(where: {id: {_eq: $id}}) {
              id
              name
              code
              phone
              address
              tax_code
              office_agency_tpls {
                office_tpl {
                  id
                  name
                }   
              }
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      update(data) {
        if(data.office_agency){
          this.listOfficeAgency = data.office_agency
          this.name = this.listOfficeAgency[0].name
          this.code = this.listOfficeAgency[0].code
          this.tax_code = this.listOfficeAgency[0].tax_code
          this.phone = this.listOfficeAgency[0].phone
          this.address = this.listOfficeAgency[0].address
          if (this.listOfficeAgency[0].office_agency_tpls.length >0) {
            for (let i = 0; i < this.listOfficeAgency[0].office_agency_tpls.length; i++) {
              const e = this.listOfficeAgency[0].office_agency_tpls[i];
              this.selectedOfficeTpl.push({id: e.office_tpl.id, name: e.office_tpl.name, __typename: "office_tpl"})
            }
          }
          console.log('ddddddddd', this.selectedOfficeTpl)
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 100%;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
